export default "__VITE_ASSET__BO$X33jl__"